(() => {
  const root = document.querySelector('.advisor-premium');
  if (!root) return;

  const replacements = new Map([
    ['Beantworten Sie 3 kurze Fragen und wir zeigen Ihnen passende Modelle für Ihre Anforderungen.', 'Beantworten Sie 3 kurze Fragen und wir zeigen Ihnen eine passende Empfehlung für Ihre Anforderungen.'],
    ['Für tägliche Nutzung im Team, Einzelbüro oder Open Space.', 'Für tägliche Nutzung im Team, Einzelbüro oder Großraumbüro.'],
    ['Für die häufigste Größenklasse mit vielseitigen Modelloptionen.', 'Für die häufigste Größenklasse mit vielseitig einstellbarer Ergonomie.'],
    ['Wir ermitteln passende Modelle für Ihr Profil', 'Wir ermitteln eine passende Empfehlung für Ihr Profil'],
    ['Auswahl ergonomisch passender Modelle', 'Abgleich mit unserem aktuell verfügbaren Sortiment'],
    ['Im Fokus stehen alltagstaugliche Modelle mit ausgewogenem Komfort für kürzere bis mittlere Sitzzeiten.', 'Im Fokus steht eine alltagstaugliche Konfiguration mit ausgewogenem Komfort für kürzere bis mittlere Sitzzeiten.'],
    ['Empfohlen sind ergonomische Modelle mit guter Unterstützung für den regelmäßigen täglichen Einsatz.', 'Im Fokus steht eine ergonomisch passende Ausstattung für den regelmäßigen täglichen Einsatz.'],
    ['Für diese Größenklasse kommen vielseitige Modelle mit breiter ergonomischer Eignung in Frage.', 'Für diese Größenklasse ist eine vielseitig einstellbare ergonomische Konfiguration besonders relevant.'],
    ['Zusätzlich berücksichtigen wir Modelle mit passender Rückenlänge, Sitzhöhe und komfortabler Unterstützung für größere Personen.', 'Zusätzlich berücksichtigen wir Rückenlänge, Sitzhöhe und komfortable Unterstützung für größere Personen.'],
    ['Modelle mit vielseitiger Passform für die häufigste Größenklasse', 'Vielseitige Passform für die häufigste Größenklasse'],
    ['Basierend auf Ihren Angaben zeigen wir Ihnen passende Modelle aus unserem aktuellen Sortiment.', 'Basierend auf Ihren Angaben zeigen wir Ihnen die passende Empfehlung aus unserem aktuell verfügbaren Sortiment.'],
    ['Homeoffice-Modelle ansehen', 'Empfehlung ansehen'],
    ['Büromodelle ansehen', 'Bürostuhl ansehen'],
    ['Modelle ansehen', 'Empfehlung ansehen'],
    ['Passende Modelle für Ihr Homeoffice', 'Passende Empfehlung für Ihr Homeoffice'],
    ['Für Ihr Homeoffice empfehlen wir ergonomische Modelle, die Komfort, Anpassbarkeit und ein ruhiges Design im Alltag verbinden.', 'Für Ihr Homeoffice empfehlen wir eine ergonomische Konfiguration, die Komfort, Anpassbarkeit und ein ruhiges Design im Alltag verbindet.'],
    ['Passende Modelle für den Büroalltag', 'Passende Empfehlung für den Büroalltag'],
    ['Für den täglichen Einsatz im Unternehmen empfehlen wir Modelle mit ergonomischer Unterstützung, robuster Konstruktion und hoher Alltagstauglichkeit.', 'Für den täglichen Einsatz im Unternehmen empfehlen wir eine ergonomische Konfiguration mit robuster Konstruktion und hoher Alltagstauglichkeit.'],
    ['Passende Modelle für Teamflächen, Einzelbüros und Open Space', 'Passend für Teamflächen, Einzelbüros und Großraumbüro'],
    ['Für größere Projekte und mehrere Arbeitsplätze empfehlen wir eine persönliche Beratung mit passender Modellauswahl, Planung und Angebotserstellung.', 'Für größere Projekte und mehrere Arbeitsplätze empfehlen wir eine persönliche Beratung zur Konfiguration, Planung und Angebotserstellung.'],
    ['Geeignete Modelle für mehrere Arbeitsplätze', 'Passende Konfiguration für mehrere Arbeitsplätze'],
    ['Empfohlene Modelle', 'Unsere Empfehlung'],
    ['Diese Modelle eignen sich für regelmäßige Nutzung im Unternehmen.', 'Dieses Modell eignet sich für regelmäßige Nutzung im Unternehmen.']
  ]);

  let applying = false;

  function alignCopy(scope) {
    if (applying || !scope) return;
    applying = true;
    try {
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      for (const node of nodes) {
        let value = node.nodeValue;
        if (!value) continue;
        for (const [from, to] of replacements) {
          if (value.includes(from)) value = value.split(from).join(to);
        }
        if (value !== node.nodeValue) node.nodeValue = value;
      }
    } finally {
      applying = false;
    }
  }

  alignCopy(root);

  const observer = new MutationObserver((mutations) => {
    if (applying) return;
    for (const mutation of mutations) {
      if (mutation.type === 'characterData') {
        alignCopy(mutation.target.parentNode || root);
      } else {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            alignCopy(node.parentNode || root);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            alignCopy(node);
          }
        });
      }
    }
  });

  observer.observe(root, { subtree: true, childList: true, characterData: true });
})();
